<script lang="ts">
    export let label: string = '';
    export let tone: 'neutral' | 'info' | 'success' | 'warn' | 'danger' = 'neutral';
    export let loading = false;
</script>

<span class="status-badge tone-{tone}">
    {#if loading}
        <i class="circle notch loading icon status-spinner" aria-hidden="true"></i>
    {/if}
    {#if $$slots.default}
        <slot />
    {:else}
        {label}
    {/if}
</span>

<style>
    .status-badge {
        display: inline-flex;
        align-items: center;
        gap: 0.375rem;
        padding: .2rem .6rem;
        border-radius: var(--radius-pill);
        font-size: var(--text-xs);
        font-weight: 500;
        line-height: 1.4;
        white-space: nowrap;
    }

    .status-spinner {
        margin: 0;
        font-size: 0.875em;
        line-height: 1;
    }

    .tone-neutral { background: var(--greyish); color: var(--grey-secondary); }
    .tone-info { background: var(--status-info-soft); color: var(--status-info-ink); }
    .tone-success { background: var(--status-success-soft); color: var(--status-success-ink); }
    .tone-warn { background: var(--status-warn-soft); color: var(--status-warn-ink); }
    .tone-danger { background: var(--status-danger-soft); color: var(--status-danger-ink); }
</style>
